export default {
  "b2b.prilohy.delete-dialog.title": "Delete attachment",
  "b2b.prilohy.delete-dialog.confrimMessage":
    "Are you sure you want to delete the attachment {name}?"
};
